import { z } from 'zod';
import { IsoTimestamp } from '../common.js';
/**
 * Phase 1.5+ — Confluence image ingestion.
 *
 * One row per *content-hashed* attachment (image). Same screenshot reused
 * across N pages collapses to a single GCS blob + a single caption +
 * single Firestore record — `hash` is the document id.
 *
 * Top-level collection: `confluence_attachments/{hash}`. Cross-tenant
 * shared corpus, kb_admin RBAC at write time. Read-time access is
 * enforced by the backend attachment proxy at /api/v1/attachments/:hash —
 * any authenticated user (regardless of tenant) can read, the same trust
 * model as Ring 1 chunks (which these images are embedded inside).
 */
export const ConfluenceAttachment = z.object({
    /** sha256 of the binary content. Used as the document ID + GCS path. */
    hash: z.string().regex(/^[a-f0-9]{64}$/),
    /** Confluence-side page that originally referenced this attachment. */
    sourceFile: z.string().min(1).max(255),
    pageId: z.string().regex(/^\d+$/),
    /** Original Confluence filename, e.g. "image-20230504-102843.png" */
    filename: z.string().min(1).max(255),
    contentType: z.string().min(1).max(120),
    sizeBytes: z.number().int().positive(),
    /** GCS path under CONFLUENCE_ATTACHMENTS_BUCKET. */
    gcsPath: z.string().min(1).max(500),
    /** Gemini Vision caption — flows into the chunk text via the markdown
     *  alt attribute and becomes part of the embedding. */
    caption: z.string().max(500).default(''),
    /** When the caption was generated. Re-runs after a code change can
     *  bump this without bumping the hash. */
    captionedAt: IsoTimestamp,
    createdAt: IsoTimestamp,
});
//# sourceMappingURL=confluence-attachment.js.map